import { DeleteOutlined as DeleteOutlinedAntd } from '@ant-design/icons';
import { Button as ButtonAntd, Typography as TypographyAntd } from 'antd';
import styled, { css } from 'styled-components';

export const DeleteOutlined = styled(DeleteOutlinedAntd)``;

export const ExcluirButton = styled(ButtonAntd)`
  border: none;
  padding: 0;
  color: #ff3c3c;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  font-size: 20px;

  &:hover,
  &:focus,
  &:active {
    color: #ff3c3c;
    opacity: 0.5;
  }
`;

export const TextStatus = styled(TypographyAntd.Text)`
  background: ${props => props.color};
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 20px;
  align-items: center;
  padding: 7px 12px;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.25px;
  color: #ffffff;
`;

export const TableRow = styled.tr`
  .ant-table-cell-fix-left:first-child {
    border-right: none;
  }
`;

export const TableCol = styled.td`
  border-color: ${props => (props.errors && '#FF3B3B') || '#E5E5E5'} !important;
  ${props =>
    props.editable === true &&
    css`
      cursor: pointer;
      text-transform: capitalize;
      :hover {
        background: #f2f2f2 !important;
        border: 1px solid #333333 !important;
      }
    `}
`;

export const EditableCol = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 14px;
  color: ${props => (props.errors && '#FF3B3B') || '#676A6C'};
  font-weight: ${props => (props.errors && 'bold') || 'normal'};
  padding: 5px 12px;
`;
